<template>
  <div class="w-100">
    Quote ACCEPTED for
    <invoice-object
      :entity-id="invoiceId()"
      :invoice="$lodash.get(activity, 'detail.invoice')"
      :open-new="true"
    />

    <b>{{ invoiceTotal() }}</b>

    <pdf-object :href="invoicePdf()" />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
